
import {initWebComponent} from "@/helpers/web-component-helper";
import {initDataTable, resizeDataTable} from "@/helpers/datatable/datatable-helper";
import {createGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import {initDataTableEditor} from "@/helpers/datatable/datatable-editor-helper";

export class LayerInfoInfoItemSubTabComponent extends HTMLElement {
    constructor(){
        super();

        const active = this.getAttribute('data-active')
        const tabName = this.getAttribute('data-tab-name')

        const template = document.createElement('template');

        template.innerHTML = `<li class="nav-item">
          <a class="nav-link nav-link-info ` + active + `" data-toggle="tab" href="#` + tabName + `">` + tabName + `</a>
        </li>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            document.querySelectorAll('.nav-link-info').forEach(element => {
                if(element.innerHTML === tabName) {
                    element.classList.add('active')
                } else {
                    element.classList.remove('active')
                }
            })
            this.closest('layer-info-info-item').querySelector('.collapse').querySelectorAll('.card').forEach(element => {
                if(element.dataset.tabName === tabName) {
                    element.classList.remove('d-none')
                } else {
                    element.classList.add('d-none')
                }
            })
            resizeDataTable()
        })
    }
}
